export { default as DialogCancelPreorder } from './DialogCancelPreorder.vue'
export { default as DialogCustomers } from './DialogCustomers.vue'
export { default as DialogEditProperties } from './DialogEditProperties.vue'
export { default as DialogGeneralNote } from './DialogGeneralNote.vue'
export { default as DialogTrackingNotes } from './DialogTrackingNotes.vue'
export { default as FormCharge } from './FormCharge.vue'
export { default as FormChargeLezhu } from './FormChargeLezhu.vue'
export { default as FormCheckout } from './FormCheckout.vue'
export { default as FormCustomers } from './FormCustomers.vue'
export { default as FormEditRoom } from './FormEditRoom.vue'
export { default as FormNewPreorder } from './FormNewPreorder.vue'
export { default as FormNewRent } from './FormNewRent.vue'
export { default as FormNewRentByDay } from './FormNewRentByDay.vue'
export { default as FormRecordMeters } from './FormRecordMeters.vue'
export { default as FormRoomCustomers } from './FormRoomCustomers.vue'
export { default as FormSignContract } from './FormSignContract.vue'
export { default as FormTransferDelegation } from './FormTransferDelegation.vue'
export { default as FormUser } from './FormUser.vue'
export { default as FormUtilities } from './FormUtilities.vue'
export { default as FormUtilitiesSettle } from './FormUtilitiesSettle.vue'



// WEBPACK FOOTER //
// ./client/src/components/forms/index.js